import "./dls-tooltip.scss";
import { IDSSTooltipProps } from "../../building-blocks/DSSFramework";
import { useCallback, useEffect, useRef, useState } from "react";
import { createRoot } from "react-dom/client";

export const DLSTooltip = ({ text, children, className }: IDSSTooltipProps) =>
{

    const containerRef = useRef<HTMLDivElement>(null);
    const tooltipRef = useRef<HTMLDivElement>(null);

    const containerID = 'tooltip-container-1234';


    const [ isOpen, setIsOpen ] = useState(false);


    useEffect(()=>{
        let widtOfDiv = 0;
        let division = 2;
        let xOffset = "-50%";
        let yOffset = "-105%";
        let className = 'center'

        const tooltipContainer = document.getElementById(containerID)?.childNodes[ 0 ] as HTMLDivElement
        if (tooltipContainer && containerRef.current && tooltipRef.current)
        {
          
            // const tooltipContainer = (tooltipRef.current as HTMLDivElement);
            widtOfDiv = containerRef.current.offsetWidth;

            if (tooltipContainer.getBoundingClientRect().left < 0)
            {
                division = 1;
                xOffset = "5%";
                yOffset = "-35%";
                className = 'left';


            }
            else if (tooltipContainer.getBoundingClientRect().right > window.innerWidth)
            {
                division = -3;
                xOffset = "-100%";
                yOffset = "-35%";
                className = 'right'
            }

            tooltipContainer.style.cssText =
                `transform: translate( calc(${ xOffset } + ${ widtOfDiv / division }px), ${ yOffset })`;
            tooltipContainer.className += ` ${ className }`;

            tooltipRef.current.className += ` ${ className }`;


        }
    },[isOpen])


    const handleMouseEnter = useCallback((event: React.MouseEvent<HTMLElement>) =>
    {

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const { top, left } = (event.target as HTMLElement).getBoundingClientRect();

        let widtOfDiv = 0;
        let division = 2;
        let xOffset = "-50%";
        let yOffset = "-105%";
        let className = 'center'


        const tooltip = <div className={ "childrencontainer" }
            style={ { transform: `translate( calc(${ xOffset } + ${ widtOfDiv / division }px), ${ yOffset })` } }

        >
            <div className={ `tooltip-box ${ className }` } ref={ tooltipRef }>{ text }</div>
        </div>

        const container = document.createElement("div");
        container.id = containerID;
        container.style.cssText = `top: ${ top + scrollTop }px; left: ${ left }px; position: absolute;`;

        document.body.appendChild(container);


        const root = createRoot(container);
        root.render(tooltip);
        setIsOpen(true)
       

    }, []);
    const handleMouseLeave = useCallback(() =>
    {
        document.getElementById(containerID)?.remove();
        setIsOpen(false)
    }, []);

    return (


        <div className="tooltipItemShell">
            <div

                className={ `tooltip-container ${ className ?? '' }` }
                onMouseEnter={ handleMouseEnter }
                onMouseLeave={ handleMouseLeave }
                ref={ containerRef }
                role="tooltip"
            >

                { children }


            </div>
        </div>
    );
}; 